export default {
  manualPromoCodeAvailable: {
    id: 'product_card_tag_generic_promo_code_label',
    defaultMessage: 'Coupon available',
  },
  manualPromoCode: {
    id: 'product_page_sticker_promo_code_headline',
    defaultMessage: 'Get {discount_value}% off with code {promo_code}',
  },
  flashSalesTag: {
    id: 'flash_sales_product_card_tag_new',
    defaultMessage: 'Flash deal',
  },
  competitiveFlashSalesTag: {
    id: 'competitive_price_product_card_tag',
    defaultMessage: 'Great price',
  },
  sellerFlashSalesTag: {
    id: 'seller_flash_sales_product_card_tag_new',
    defaultMessage: 'Price drop',
  },
} as const
